import { connect } from 'react-redux';
import { moveNext, movePrev } from '../redux/actionCreators';
import { getDuperbrowseNavigation, getIsDuperbrowseActive, getIsKeyboardDuperbrowseAllowed } from '../redux/selectors';
const mapStateToProps = (state)=>({
        navigation: getDuperbrowseNavigation(state),
        isDuperbrowseActive: getIsDuperbrowseActive(state),
        enableKeyboardNavigation: getIsKeyboardDuperbrowseAllowed(state)
    });
const mapDispatchToProps = {
    moveNext,
    movePrev
};
export default connect(mapStateToProps, mapDispatchToProps);
